import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const FavoritesLimitReachedModalDialog = () =>
  import(/* webpackChunkName: "4-feat-favorites-limit-reached-modal-dialog" */ './FavoritesLimitReachedModalDialog');

export default lazyLoadOnRender({ loader: FavoritesLimitReachedModalDialog });
